let onSessionExpired = null;

export const setSessionExpiredHandler = (handler) => {
    onSessionExpired = handler;
};

export const triggerSessionExpired = () => {
    if (onSessionExpired) {
        onSessionExpired();
    }
};